export default [
  {
    path: "/createtopic",
    name: "create.topic",
    meta: {
      title: "发帖",
    },
    component: () => import("./CreateTopic"),
  },
  {
    path: "/topic/:topicId",
    name: "topic.detail",
    meta: {
      title: "帖子",
    },
    component: () => import("./TopicDetail"),
  },
  {
    path: "/user/topic",
    name: 'user.topic',
    meta: {
      title: '编辑稿件'
    },
    component: () => import("./UserTopic"),
  }
];
